export default "__VITE_ASSET__CsM7c1vg__"